import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { BarsProgressDuotone } from './icons/bars-progress-duotone';
import { useSession } from 'next-auth/react';
import { getAccount } from 'utils/sessionHelper';
import { useFirebaseUser } from 'utils/useFirebaseUser';
import { usePostCommentBox } from 'components/engage/reply-to-comments/use-post-comment-box';

export const EngageWithComments = () => {
  const { data: session, status } = useSession() ?? {};
  const isAuthenticated = useFirebaseUser();
  const account = getAccount(session);
  let isValidToken = account?.thWriteAccessToken;
  const { PostCommentBox, recentPosts } = usePostCommentBox({
    postLimits: 5,
    commentFetchLimists: account?.subscription?.plan == 'enterprise' ? 500 : 25,
    username: account?.username,
    idLinkedin: account?.idLinkedin,
    dashEntityUrn: account?.dashEntityUrn,
    isAuthenticated: isAuthenticated,
    isValidToken: isValidToken,
    idUser: account?.id,
    hasLoadMoreButton: true,
    dense: true,
    onlyPostsWithComments: true,
    hasReducedView: true,
  });

  return recentPosts.length > 3 ? (
    <Card w="100%" flexShrink={0}>
      <CardHeader>
        <Heading size="sm">
          <Flex gap={2} alignItems="center">
            <BarsProgressDuotone />
            <Text>Engage with people who comment on your posts</Text>
          </Flex>
        </Heading>
      </CardHeader>
      <CardBody>
        <PostCommentBox />
      </CardBody>
    </Card>
  ) : null;
};
